import { generateId } from 'utilities/uniqueId'
import { NavigationTab, NavigationTabIcon } from './types'

// Helper function to generate unique tab IDs
export const generateUniqueTabId = (
  existingTabs: Record<string, NavigationTab>
): string => {
  let newId: string
  do {
    // Generate a UUID and prefix it with 'tab-'
    newId = `tab-${generateId()}`
  } while (existingTabs[newId]) // Keep generating until we get a unique ID (extremely unlikely to collide)

  return newId
}

/**
 * Get the appropriate image URL for a NavigationTabIcon.
 * Returns pendingImage if available and url is empty/null, otherwise returns url.
 * This replicates the behavior used in AppHomePage contentBlocks.
 */
export const getImageUrl = (
  icon: NavigationTabIcon | null | undefined
): string | null => {
  if (!icon) {
    return null
  }

  // If we have a pending image and no URL (or empty URL), use pending image
  if (icon.pendingImage && (!icon.url || icon.url === '')) {
    return icon.pendingImage
  }

  // Otherwise use the URL
  return icon.url || null
}
